import React, { useState } from 'react';
import {
  GridContainer,
  GridIcon,
  GridInput,
  GridItem,
} from './GridIconField.styled';
import EmojiIcon from '@components/atoms/Icon/EmojiIcon';

const GridIconField = ({
  contextValue,
  options,
  handleFormData,
  handleEvent,
  id,
}) => {
  const [selectedItem, setSelectedItem] = useState(
    Number(contextValue) || null
  );

  const handleFieldChange = (key, value) => {
    setSelectedItem(value);
    handleFormData({ name: key, value });
    //TODO : FIND A WAY TO MAKE THIS AGNOSTIC
    handleFormData({name:'idFormationBitrix', value:null});
    if (typeof handleEvent === 'function') {
      handleEvent();
    }
  };

  return (
    <GridContainer>
      {options
        .sort((a, b) => a.index - b.index)
        .map((option, index) => (
        <GridItem
          key={index}
          onClick={(event) => {
            if (event.target.value && event.target.checked) {
              setSelectedItem(event.target.value);
              handleFieldChange(id, event.target.value);
            }
          }}
          $active={selectedItem === option.id}
        >
          <GridInput
            id={`radio-${index}`}
            name={option.name}
            value={Number(option.id)}
            checked={(selectedItem === Number(option.id))}
            onChange={(e) => e.preventDefault()}
          />
          <GridIcon>
            <EmojiIcon name={option.icon} />
          </GridIcon>
          <p>{option.name}</p>
        </GridItem>
      ))}
    </GridContainer>
  );
};

export default GridIconField;
